import { Pipe, PipeTransform } from '@angular/core';
import { Shift, ShiftType } from '@model/reservation';
import { Common } from '../lib/common-methods';

@Pipe({
  name: 'shiftFromToHour',
})
export class ShiftFromToHourPipe implements PipeTransform {

  transform(value: Shift, ...args: unknown[]): unknown {
    if (!value) {
      return '';
    }

    return `${Common.padStart(value.fromHour, 2)}:${Common.padStart(value.fromMin, 2)} - ${Common.padStart(value.toHour, 2)}:${Common.padStart(value.toMin, 2)}`;
  }

}
